var exports = {
  "k": "x31de4314--615de8--container",
  "P": "x31de4314--615de8--label",
};

module.exports = exports;
